<template>
  <Modal v-if="showModalChooseDelivery" @close="$emit('closeModal')">
    <Loading v-if="loading" />
    <div class="chooseDelivery">
      <div class="chooseDelivery__header">
        <span class="title">{{ $t('chooseDelivery') }}</span>
        <img
          src="@/assets/icons/CloseModal.svg"
          alt="CloseModal"
          @click="$emit('closeModal')"
        />
      </div>
      <div class="chooseDelivery__body">
        <Table
          v-if="data.length"
          :data="data"
          :columns="columns"
          selectedField="deliveryId"
          @assignDeliveryTable="assignDeliveryTable"
        />
        <div v-if="!data.length" class="chooseDelivery__body-noTable">
          <p>{{ $t('noReservations') }}</p>
        </div>
      </div>
      <Button
        variant="redBordered"
        :title="$t('cancel')"
        @click="$emit('closeModal')"
      />
      <AddPhoneNumber
        :showModalAddPhoneNumber="showModalAddPhoneNumber"
        @assignReservation="assignReservation"
        @closeModal="showModalAddPhoneNumber = false"
      />
    </div>
  </Modal>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import { mapActions, mapState } from 'vuex';

import Loading from '@/views/Loading.vue';
import AddPhoneNumber from '@/duplicatePages/AddPhoneNumber/AddPhoneNumber.vue';

import { columns } from './configs';
import { DataReservations } from '@/store/modules/pharmacy/types';

@Options({
  name: 'ChooseDelivery',
  props: ['showModalChooseDelivery', 'activeBoxId', 'activeLocker'],
  components: {
    Loading,
    AddPhoneNumber
  },
  data() {
    return {
      data: [],
      reservations: [],
      payload: null,
      activeReservations: null,
      columns: columns(this.$t),
      loading: false,
      showModalAddPhoneNumber: false
    };
  },
  created() {
    this.show();
  },
  computed: {
    ...mapState('pharmacy', ['pharmacy'])
  },
  methods: {
    ...mapActions('pharmacy', [
      'assignDelivery',
      'getPharmacy',
      'getPickupBoxesByPharmacy'
    ]),
    async show() {
      this.loading = true;

      if (this.pharmacy) {
        this.reservations = this.pharmacy?.reservations;

        this.data = [...this.reservations]?.filter(
          (reservation: DataReservations) => reservation.unassigned === true
        );
      }

      this.loading = false;
    },
    async assignDeliveryTable(deliveryId: string) {
      this.activeReservations = this.data.find(
        (i: DataReservations) => i.deliveryId === deliveryId
      );

      if (this.activeReservations.phoneNumber.length === 0) {
        this.showModalAddPhoneNumber = true;
      } else {
        this.assignDeliveryRequest();
      }
    },
    async assignDeliveryRequest(phoneNumber: string) {
      this.loading = true;

      const { id } = this.$route.params;

      if (phoneNumber) {
        this.payload = {
          assignToBox: true,
          boxInfo: {
            lockerId: [this.activeLocker],
            boxId: this.activeBoxId,
            customerPhoneNumber: phoneNumber
          }
        };
      } else {
        this.payload = {
          assignToBox: true,
          boxInfo: {
            lockerId: [this.activeLocker],
            boxId: this.activeBoxId
          }
        };
      }

      await this.assignDelivery({
        data: this.payload,
        pharmacyId: id,
        deliveryId: this.activeReservations.deliveryId
      });

      this.$emit('closeModal');

      await this.getPharmacy(id);
      await this.getPickupBoxesByPharmacy(id);

      this.loading = false;

      this.show();
    },
    assignReservation(phoneNumber: string) {
      this.showModalAddPhoneNumber = false;
      this.assignDeliveryRequest(phoneNumber);
    }
  }
})
export default class ChooseDelivery extends Vue {}
</script>

<style lang="scss" scoped>
.chooseDelivery {
  width: 460px;
  height: 100vh;
  max-height: 450px;
  padding: 24px;
  .chooseDelivery__header {
    display: flex;
    justify-content: space-between;
    .title {
      font-family: 'Ubuntu-Medium';
      font-size: $eighteenSize;
    }
    img {
      cursor: pointer;
    }
  }
  .chooseDelivery__body {
    height: calc(100% - 110px);
    padding: 24px 0;
    .text {
      color: $label;
      font-size: $fourteenSize;
      line-height: $twentyTwoSize;
      font-weight: 500;
    }
  }
}
</style>
